namespace Gamification.Gamification {
    export interface ExtendedStandardResponse {
        Dummy?: string;
        Json?: string;
    }
}
